import React from 'react';
import {emitEventLog} from '@di-shared/features/analytics';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

interface DemeritEducationReservationSuccessBottomSheetData {
  centerName: string;
  eduDate: string;
  eduTime: string;
  centerNotice: string;
}

function DemeritEducationReservationSuccessBottomSheet() {
  const {t} = useInferableTranslation();
  const {centerName, eduDate, eduTime, centerNotice} = (window as any).data as DemeritEducationReservationSuccessBottomSheetData;

  return (
    <div className="bottom_sheet bottom_sheet_reservation">
      <div className="bottom_sheet_header">
        <h2 className="bottom_sheet_title">{t('T10334')}</h2>
        <button
          type="button"
          className="btn btn_ic"
          aria-label={t('T10017')}
          onClick={() => window.bottomSheetClose()}
        >
          <span
            className="ic ic_close_20px"
            aria-hidden="true"
          />
        </button>
      </div>
      <div className="bottom_sheet_inner">
        <div className="bottom_sheet_contents">
          <div className="bottom_sheet_container">
            <dl className="vehicle_info align_left">
              <div className="vehicle_item">
                <dt className="info_title">{t('T10335')}</dt>
                <dd className="info_text">{centerName}</dd>
              </div>
              <div className="vehicle_item">
                <dt className="info_title">{t('T10275')}</dt>
                <dd className="info_text">{eduDate}</dd>
              </div>
              <div className="vehicle_item">
                <dt className="info_title">{t('T10054')}</dt>
                <dd className="info_text">{eduTime}</dd>
              </div>
            </dl>
          </div>
          <strong className="notice_title">{t('T10336')}</strong>
        </div>
        <ul className="notice_list">
          <li className="notice_item">{centerNotice}</li>
        </ul>
        <div className="bottom_sheet_footer bottom_sheet_footer_complex">
          <button
            type="button"
            className="btn btn_large btn_outline"
            onClick={() => window.bottomSheetClose()}
          >
            {t('T10316')}
          </button>
          <button
            type="button"
            className="btn btn_large btn_filled"
            onClick={() => {
              emitEventLog({
                event: 'public_service_interaction',
                data_action: 'Demerit reduction education',
                data_name: 'demerit final confirm click',
              });
              window.bottomSheetClose(true);
            }}
          >
            {t('T10114')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DemeritEducationReservationSuccessBottomSheet;
